import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { configData } from "../../../services/api-config";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Employee } from '../../../services';

const ConfirmEmployeePage = () => {
    const { t } = useTranslation(); // Initialize useTranslation
    const { code } = useParams();
    console.log(code);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState();
    const [emailError, setEmailError] = useState(false);
    const [loader, setLoader] = useState(false);
    const [errorTitle, setErrorTitle] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        setLoader(true);
        Employee.getEmailByEmployee(code)
            .then((response) => {
                console.log('get email by code response', response);
                if (response.status === 200) {
                    setEmail(response.data);
                    console.log('email', email);
                } else {
                    console.log(t('confirmEmployee.error.generic')); // Use translation
                    setEmailError(true);
                }
                setLoader(false);
            })
            .catch(() => {
                console.log(t('confirmEmployee.error.generic')); // Use translation
                setLoader(false);
                setEmailError(true);
            });
    }, []);


    const setPasswordEmployee = () => {
        console.log('send code');
        if (password && confirmPassword) {
            if (password === confirmPassword) {
                setErrorTitle();
                setIsLoading(true);

                const data = {
                    "email": email,
                    "password": password,
                    "confirmPassword": confirmPassword
                };

                Employee.setEmployeePassword(code, data)
                    .then((response) => {
                        console.log('set new password response', response);
                        if (response.status == 200) {
                            console.log('password set success');
                            setIsSuccess(true);
                        }
                        setIsLoading(false);
                    })
                    .catch(() => {
                        console.log(t('confirmEmployee.error.generic')); // Use translation
                        setErrorTitle(t('confirmEmployee.error.generic')); // Use translation
                        setIsLoading(false);
                    });
            } else {
                setErrorTitle(t('confirmEmployee.error.passwordMismatch')); // Use translation
            }
        } else {
            setErrorTitle(t('confirmEmployee.error.fillAllFields')); // Use translation
        }
    }

    const renderContent = () => {
        if (!loader) {
            if (!emailError) {
                if (isSuccess) {
                    return (
                        <div style={{ marginTop: '16px', backgroundColor: '#ffffff', borderRadius: '24px', textAlign: 'center' }}>
                            <div>
                                <div style={{ display: 'inline-block', backgroundColor: 'rgba(19, 182, 94, 0.1)', width: '80px', height: '80px', borderRadius: '50%' }}>
                                    <div style={{ height: '20px', marginTop: '28px' }}>
                                        <img src="/icons/tick-success.svg" height="22px" />
                                    </div>
                                </div>
                            </div>

                            <div style={{ fontSize: '18px', fontFamily: 'Gerbera-Bold', marginTop: '24px' }}>{t('confirmEmployee.success.passwordSavedTitle')}</div>
                            <div style={{ fontSize: '15px', marginTop: '16px', textAlign: 'center', color: '#A3ACB6' }}>{t('confirmEmployee.success.passwordSavedSummary')}</div>

                            <Link to="/login" style={{ textDecoration: 'none' }}>
                                <div style={{ fontSize: '15px', marginTop: '16px', padding: '8px', color: '#A3195B' }}>{t('confirmEmployee.button.login')}</div>
                            </Link>
                        </div>
                    );
                } else {
                    return (
                        <>
                            <div style={{ fontSize: '14px', marginTop: '12px', color: '#A3ACB6' }}>{t('confirmEmployee.prompt.createPassword')}</div>
                            <div style={{ marginTop: '24px' }}>
                                <Form.Control type="email" value={email} size="lg" style={{ fontSize: '16px', padding: '12px 16px', pointerEvents: 'none', opacity: '0.7' }} />
                            </div>
                            <div style={{ marginTop: '24px' }}>
                                <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} size="lg" placeholder={t('confirmEmployee.placeholder.enterPassword')} style={{ fontSize: '16px', padding: '12px 16px' }} />
                            </div>
                            <div style={{ marginTop: '16px' }}>
                                <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} size="lg" placeholder={t('confirmEmployee.placeholder.repeatPassword')} style={{ fontSize: '16px', padding: '12px 16px' }} />
                            </div>

                            {errorTitle && <div style={{ marginTop: '12px', fontSize: '13px', color: 'red' }}>{errorTitle}</div>}

                            {
                                isLoading
                                    ?
                                    <div style={{ width: '100%', backgroundColor: '#A3195B', borderRadius: '8px', padding: '19px 14px 18px', border: 'none', color: '#ffffff', fontWeight: '500', marginTop: '20px' }}>
                                        <div className="loader white" style={{ margin: '0 auto' }}></div>
                                    </div>
                                    :
                                    <div>
                                        <button onClick={setPasswordEmployee} style={{ width: '100%', backgroundColor: '#A3195B', borderRadius: '8px', padding: '14px', border: 'none', color: '#ffffff', fontWeight: '500', marginTop: '20px' }}>{t('confirmEmployee.button.savePassword')}</button>
                                    </div>
                            }
                        </>
                    );
                }
            } else {
                return (
                    <>
                        <div style={{ padding: '32px 0 24px', color: 'red', fontSize: '14px' }}>{t('confirmEmployee.error.activationExpired')}</div>
                        <Link to="/login" style={{ textDecoration: 'none', color: '#000000' }}>
                            <div style={{ fontSize: '13px', marginTop: '8px', padding: '8px' }}>{t('login.loginButton')}</div> {/* Reusing login button text */}
                        </Link>
                    </>
                );
            }
        } else {
            return (
                <div style={{ padding: '64px 24px' }}>
                    <div className='loader brand' style={{ margin: '0 auto' }}></div>
                    <div style={{ marginTop: '12px', fontSize: '14px' }}>{t('confirmEmployee.loading.data')}</div>
                </div>
            );

        }
    }


    return (
        <div style={{ backgroundColor: '#f0f4f7', height: '100vh', width: '100vw', fontFamily: 'Inter', fontWeight: 400, position: 'relative' }}>
            <div style={{ position: 'absolute', top: '24px', left: '16px' }}>
                <img src="/icons/logo.svg" height="40px" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <div style={{ backgroundColor: '#ffffff', boxShadow: '0 2px 6px -2px rgb(228, 228, 228)', width: '380px', borderRadius: '24px', padding: '38px 44px', textAlign: 'center' }}>
                    <div style={{ fontSize: '24px', fontFamily: 'Inter', fontWeight: 700 }}>{t('confirmEmployee.title')}</div>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}

export default ConfirmEmployeePage;
